import { Box, Grid, Paper, Typography } from "@mui/material";

const EntityOverviewCard = ({ fields, image, testId }) => (
  <Paper
    data-testid={testId}
    sx={{
      p: 1.5,
      backgroundColor: "#333333",
      borderLeft: "4px solid #14b8a6",
      mb: 2,
    }}
  >
    {image && <Box sx={{ mb: 0.5 }}>{image}</Box>}
    <Grid container spacing={1}>
      {fields.map(({ label, value }) => (
        <Grid item xs={12} sm={6} key={label}>
          <Typography variant="body2" sx={{ color: "#999999", fontSize: "11px" }}>
            {label}
          </Typography>
          <Typography variant="body1" sx={{ color: "white" }}>
            {value ?? "—"}
          </Typography>
        </Grid>
      ))}
    </Grid>
  </Paper>
);

export default EntityOverviewCard;
